"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";

import { DeviceSwitcher } from "@/components/device-switcher";
import { NavUser } from "@/components/nav-user";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarRail,
} from "@/components/ui/sidebar";
import { CONSOLE_TABS } from "@/lib/navigation";

export function AppSidebar() {
  const pathname = usePathname();
  return (
    <Sidebar collapsible="icon">
      <SidebarHeader>
        <DeviceSwitcher />
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu>
              {CONSOLE_TABS.map((tab) => (
                <SidebarMenuItem key={tab.href}>
                  <SidebarMenuButton
                    asChild
                    tooltip={tab.title}
                    isActive={tab.href === "/" ? pathname === "/" : pathname.startsWith(tab.href)}
                  >
                    <Link href={tab.href}>
                      <tab.icon />
                      <span>{tab.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        <NavUser />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  );
}
